import React from 'react'

const Author = () => {
  return <h3>jcarbajal79</h3>
}

export default Author
